import { Component, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { EntityEnum } from 'src/app/models/contract';
import { IBeneficiary, IGenericContract, IGenericContractFormGroup } from 'src/app/models/generic';
import { ApiContractService } from 'src/app/services/api/api-contract.service';

@Component({
  selector: 'app-contrato-detalhes',
  templateUrl: './contrato-detalhes.component.html',
  styleUrls: ['./contrato-detalhes.component.scss']
})
export class ContratoDetalhesComponent implements OnDestroy {
  tabTitle = 'detalhes';

  currentMode = 'visualizar';

  contractData!: IGenericContract;

  editableFieldNames: string[] = [];

  subs: Subscription[] = [];

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _contractService: ApiContractService
  ) {
    const routeSub = this._activatedRoute.params.subscribe((params) => {
      this.currentMode = params['mode'] ?? 'visualizar';
    });

    const formReadySub = this._contractService.checkIfFormIsReady().subscribe({
      next: (isReady) => {
        if (isReady) {
          this.contractData = this._contractService.contractData;
          this.editableFieldNames = (this.contractData.EditableFields || [])
            .filter((el) => el.Entity === EntityEnum.Contract)
            .map((el) => el.Field);
        }
      }
    });

    this.subs.push(routeSub, formReadySub);
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }

  get isEditMode(): boolean {
    return this.currentMode === 'editar';
  }

  isFieldEditable(field: string): boolean {
    return this.isEditMode && this.editableFieldNames.includes(field);
  }

  get form(): FormGroup<IGenericContractFormGroup> {
    return this._contractService.getForm();
  }

  get parceiro(): IBeneficiary | undefined {
    return this.contractData?.Beneficiaries?.find(
      (b) => (b.BeneficiaryType || '').toLowerCase() === 'parceiro'
    );
  }

  get subsidiaria(): IBeneficiary | undefined {
    return this.contractData?.Beneficiaries?.find(
      (b) => (b.BeneficiaryType || '').toLowerCase() === 'subsidiaria'
    );
  }

  customField(fieldName: string): string {
    return this.contractData?.ContractCustomFields?.find(
      (f) => f.FieldName.toLowerCase() === fieldName.toLowerCase()
    )?.Value || '-';
  }
}
